import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

interface ReleaseNotesPopupProps {
  isOpen: boolean;
  onClose: () => void;
}

export function ReleaseNotesPopup({ isOpen, onClose }: ReleaseNotesPopupProps) {
  const releaseNotesText = "First release, known bugs include some issues with backdated decisions and some sidebar issues for medium sized devices/screens. Missing features in development include transactional emails for notifications and onboarding. Some marketing content (blog, best practices) currently is just placeholder AI generated text. Send feedback, bug reports and feature requests to feedback@decisionr.xyz. Thanks";

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle className="text-xl font-semibold">Current Release Notes</DialogTitle>
        </DialogHeader>
        <DialogDescription asChild>
          <div className="space-y-4">
            <p className="text-sm text-muted-foreground leading-relaxed">
              {releaseNotesText}
            </p>
            <div className="flex justify-end">
              <Button onClick={onClose} className="w-24">
                Close
              </Button>
            </div>
          </div>
        </DialogDescription>
      </DialogContent>
    </Dialog>
  );
}